import React from 'react'
import Card from 'react-bootstrap/Card'
import { useState, useEffect } from 'react'
import { getTopupRecords } from '../../helpers/APIHelper'
import { Table,Button } from 'react-bootstrap'
import { IoIosArrowBack } from "react-icons/io";
import { useHistory } from "react-router-dom";
import PaginationButton from '../PaginationButton'
import Bubbles from '../loading/Bubbles';

const TopupRecords = ( {setAuthentication} ) => {

    let history = useHistory();

    const [isLoading, setLoading] = useState(true)
    const [pageNumber, setPageNumber] = useState(1)
    const [data, setData] = useState({
        data : {}
    })

    useEffect(() => {
        async function fetchData() {
            await fetchInitialData();
        }
        fetchData();
    }, [pageNumber]);

    const fetchInitialData = async () => {
        var result = await getTopupRecords(pageNumber, setAuthentication);
        if(result !== null) {
            if(result.status === 200) {
                setData(result.data)
                setLoading(false)
            }
        }
    }

    return (
        <Card className="ran-card">
            <Card.Header className="ran-card-header text-white">
                TOPUP RECORDS
            <Button onClick={() => history.goBack() }  variant="warning" className="text-dark" style={{float:"right"}}>
               <IoIosArrowBack /> BACK
            </Button>          
            </Card.Header>
            <Card.Body>
                {
                    isLoading ? 
                    (
                        <Bubbles />
                    )
                    : 
                    (
                        <>
                            <Table striped bordered hover variant="dark" responsive>
                                <thead>
                                    <tr>
                                        <th>Ref #</th>
                                        <th>Date Created</th>
                                        <th>Item #</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                   { data.dataList.map((item, index) => 
                                     <tr key={index}>
                                        <td>{item.referenceId}</td>
                                        <td>{item.dateCreated}</td>
                                        <td>{item.itemId}</td>
                                        <td>{item.amount}</td>
                                        {
                                            item.status === 'PAID' ?
                                            <td style={{ color:"yellow" }}>{item.status}</td>
                                            : <td style={{ color:"green" }}>{item.status}</td>
                                        }
                                         
                                    </tr>
                                   )}
                                </tbody>
                            </Table>
                            <PaginationButton data={data} setPageNumber={setPageNumber} />
                        </>
                    )
                }
            </Card.Body>
        </Card>
    )
}

export default TopupRecords
